<mat-form-field class="flex grow" subscriptSizing="dynamic">
  <mat-label>Is</mat-label>
  <mat-select required [formControl]="valueCtrl">
    @for (option of options; track option.value) {
      <mat-option [value]="option">
        {{ option.label }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
